export default () => {
	const infoNode = document.getElementById('info');

	infoNode.style.display = "block";
	
	return () => {
		infoNode.style.display = "none";
	};
}